export const linkRoutes = [
    {
      url: "/marvel",
      label: "Marvel",
    },
    {
      url: "/dc",
      label: "DC",
    },
    {
      url: "/bha",
      label: "BHA",
    },
    {
      url: "/search",
      label: "Search",
    },
  ];